
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home_page1",
      function () {
        return require("private-next-pages/home_page1.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home_page1"])
      });
    }
  